const n = (t) => Number(t), s = (t) => Number(t), e = (t) => t / 100, o = (t) => Number(t) * 100;
export {
  n as cents,
  e as centsToUnits,
  s as units,
  o as unitsToCents
};
